<template>
    <header v-if="verifyStatusCadastro" class="site-header">
        <div class="logo">
            <img src="@/assets/logoHeader.png" v-if="nomeEmpresa == 'BRITECH' || nomeEmpresa == 'DNWAYS_DEMO_Y' || nomeEmpresa == 'DNWAYS_DEMO_X'" style="filter: invert(60%);" />
            <img src="@/assets/dnways.png" v-if="nomeEmpresa == 'Vortex'" style="width: 100%; height: 100%;" />
            <img src="@/assets/logoActual_v2.png" v-if="nomeEmpresa == 'ACTUAL'" style="width: 90%; height: 90%;" />
            <img src="@/assets/logogenial.png" v-if="nomeEmpresa == 'GENIAL'" style="width: 100%; height: 100%;" />
            <img src="@/assets/logoHeader_rji.png" v-if="nomeEmpresa == 'RJI'" />
        </div>
        <nav class="navigation">
            <ul>
                <li><button type="button" v-if="configuracaoToken != 'S'" class="button button-light" @click="alterarSenha()"
                        style="cursor: pointer;">Alterar senha</button></li>
                <li><button type="button" @click="logoff" style="cursor: pointer;" class="submit-button">Logoff</button>
                </li>
            </ul>
        </nav>
    </header>
    <div v-if="verifyStatusCadastro" class="container">
        <div class="header">
            <span>Olá, {{ user?.NomeRazaoSocial }} </span>
        </div>
        <div class="quadro-inicial" v-if="!inicializado">
             <div class="loading-overlay">
                <div class="spinner"></div>
            </div>
        </div>
        <div class="quadro-inicial" v-if="inicializado">
            <div class="quadro-status-cadastro" :style="this.user?.StatusCadastro == 2 && habilitaRenovacao ? 'width: 33% !important;' : ''">
                <div v-if="this.user?.StatusCadastro == 1" class="status-cadastro-content">
                    <img src="@/assets/pendente.svg" />
                    <div class="status-text">
                        <span class="status">Cadastro em aprovação</span>
                        <span class="desc">Seu cadastro está em processo de aprovação</span>
                    </div>
                </div>
                <div v-if="this.user?.StatusCadastro == 2 && habilitaRenovacao" class="status-cadastro-content">
                    <img src="@/assets/pendente.svg" />
                    <div class="status-text">
                        <span class="status">Atualização cadastral pendente</span>
                        <span class="desc">Garanta que suas informações estejam atualizadas para garantir o acesso aos nosso serviços</span>
                    </div>
                </div>
                <div v-if="this.user?.StatusCadastro == 2 && !habilitaRenovacao" class="status-cadastro-content">
                    <img src="@/assets/aprovado.png" />
                    <div class="status-text">
                        <span class="status">Cadastro aprovado</span>
                        <span class="desc">Seu cadastro foi aprovado!</span>
                    </div>
                </div>
                <div v-if="this.user?.StatusCadastro == 3" class="status-cadastro-content">
                    <img src="@/assets/pendente.svg" />
                    <div class="status-text">
                        <span class="status">Cadastro vencido</span>
                        <span class="desc">Seu cadastro está vencido</span>
                    </div>
                </div>
                <div v-if="this.user?.StatusCadastro == 4" class="status-cadastro-content">
                    <img src="@/assets/pendente.svg" />
                    <div class="status-text">
                        <span class="status">Cadastro em revisão</span>
                        <span class="desc">Seu cadastro está em revisão</span>
                    </div>
                </div>
                <div v-if="this.user?.StatusCadastro == 5" class="status-cadastro-content">
                    <img src="@/assets/pendente.svg" />
                    <div class="status-text">
                        <span class="status">Cadastro inativo</span>
                        <span class="desc">Seu cadastro está inativo</span>
                    </div>
                </div>
                <div class="buttonsAcoes">
                    <button class="btnDefault" style="width: 140px;" @click="downloadFicha()">Download cadastro</button>
                    <button class="btnDefault" style="width: 140px;" v-if="possuiMockPosicaoPas" @click="visualizarPosicao()">Visualizar posição</button>
                </div>
            </div>
            <div class="quadro-perfil" :style="habilitarModalCadastroAlterado ? 'width: 33% !important;' : ''" v-if="user?.TipoCliente != 'Fundos'">
                <span class="status">Perfil investidor: {{ perfilSuitabilityPreview ? perfilSuitabilityPreview.Perfil : dadosUsuario.PerfilRisco }}</span>
                <span class="desc">Esse é o resultado do seu perfil. Caso queira, você poderá refazê-lo.</span>
                <div class="buttonsAcoes">
                    <button class="btnBlue" style="width: 180px !important" :class="{btnFundoLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(9)}" @click="abrirQuestionario()">{{labelAbrirQuestionario}}</button>
                    <button class="btnDefault" @click="abrirSaibaMais()">Saiba mais</button>
                </div>
            </div>
            <div v-if="habilitarModalCadastroAlterado" style="width: 33% !important" class="quadro-perfil quadro-perfil-azul">
                <span class="status">Cadastro Alterado</span>
                <span class="desc">Você efetuou as alterações em seu cadastro, mas elas ainda não foram enviadas. Ao clicar em "Enviar cadastro atualizado", todas as informações salvas serão enviadas para análise e registro.</span>
                <div class="buttonsAcoes" style="margin-top: 10px !important;">
                    <button class="btnAmarelo" :class="{btnFundoLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(9)}" @click="enviarCadastro()">Enviar cadastro atualizado</button>
                </div>
            </div>
        </div>
        <div class="quadros-configuracoes" v-if="user?.TipoCliente == 'Pessoa Física'">
            <div style="width: 100%; display: inline-flex;">
                <div class="voltar-dash" style="width: 80px;" v-if="editar && numEtapa != 9">
                    <button type="button" class="submit-button white-button" style="cursor: pointer; margin-top: 10px;"
                        @click="sairEdicao()">Voltar</button>
                </div>
                <div class="desc-dash" style="width: 30%; display: grid;">
                    <span class="title">Cadastro</span>
                    <span class="subtitle" style="color: #475467">Se necessário, revise seus dados cadastrados
                        abaixo</span>
                </div>
            </div>
            <div v-if="!editar || numEtapa == 9">
                <div class="agrupamento-quadros">
                    <div class="quadro-configuracao quadro-configuracao-primeiro">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Dados Cadastrais</span>
                        </div>
                        <span class="desc">Informações pessoais do seu cadastro.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(0), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(0)}"  @click="abrirEditor(0)">{{verificaSeJaConcluiuEtapa(0) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Procuradores</span>
                        </div>
                        <span class="desc">Informações dos procuradores</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(1), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(1)}"  @click="abrirEditor(1)">{{verificaSeJaConcluiuEtapa(1) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Dados Financeiros</span>
                        </div>
                        <span class="desc">Situação financeira e patrimonial</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(2), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(2)}"  @click="abrirEditor(2)">{{verificaSeJaConcluiuEtapa(2) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="agrupamento-quadros">
                    <div class="quadro-configuracao  quadro-configuracao-primeiro" v-if="nomeEmpresa != 'GENIAL'">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Dados Bancários</span>
                        </div>
                        <span class="desc">Suas contas bancarias</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(3), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(3)}"  @click="abrirEditor(3)">{{verificaSeJaConcluiuEtapa(3) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Endereço</span>
                        </div>
                        <span class="desc">Informações pessoais do seu cadastro.</span>

                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(4), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(4)}"  @click="abrirEditor(4)">{{verificaSeJaConcluiuEtapa(4) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Documentos</span>
                        </div>
                        <span class="desc">Arquivos anexados</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(5), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(5)}"  @click="abrirEditor(5)">{{verificaSeJaConcluiuEtapa(5) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="agrupamento-quadros">
                    <div class="quadro-configuracao quadro-configuracao-primeiro">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Declarações</span>
                        </div>
                        <span class="desc">Termos aceitos</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(6), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(6)}"  @click="abrirEditor(6)">{{verificaSeJaConcluiuEtapa(6) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao ">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Produtos</span>
                        </div>
                        <span class="desc">Produtos com base no seu perfil investidor.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(7), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(7)}"  @click="abrirEditor(7)">{{verificaSeJaConcluiuEtapa(7) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="editar && numEtapa != 9">
                <CadastroPF v-model:Edicao="editar" :BloquearSalvarIsolado="habilitaRenovacao" />
            </div>
        </div>
        <div class="quadros-configuracoes" v-if="user?.TipoCliente == 'Pessoa Jurídica'">
            <div style="width: 100%; display: inline-flex;">
                <div class="voltar-dash" style="width: 80px;" v-if="editar && numEtapa != 9">
                    <button type="button" class="submit-button white-button" style="cursor: pointer; margin-top: 10px;"
                        @click="sairEdicao()">Voltar</button>
                </div>
                <div class="desc-dash" style="width: 30%; display: grid;">
                    <span class="title">Cadastro</span>
                    <span class="subtitle" style="color: #475467">Se necessário, revise seus dados cadastrados
                        abaixo</span>
                </div>
            </div>
            <div v-if="!editar || numEtapa == 9">
                <div class="agrupamento-quadros">
                    <div class="quadro-configuracao quadro-configuracao-primeiro">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Dados da Empresa</span>
                        </div>
                        <span class="desc">Informações do seu cadastro.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(0), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(0)}"  @click="abrirEditor(0)">{{verificaSeJaConcluiuEtapa(0) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Procuradores</span>
                        </div>
                        <span class="desc">Informações dos procuradores da empresa.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(1), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(1)}"  @click="abrirEditor(1)">{{verificaSeJaConcluiuEtapa(1) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Representantes</span>
                        </div>
                        <span class="desc">Informações dos representantes da empresa.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(2), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(2)}"  @click="abrirEditor(2)">{{verificaSeJaConcluiuEtapa(2) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="agrupamento-quadros">
                    <div class="quadro-configuracao  quadro-configuracao-primeiro">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Dados Financeiros</span>
                        </div>
                        <span class="desc">Situação financeira e patrimonial</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(3), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(3)}"  @click="abrirEditor(3)">{{verificaSeJaConcluiuEtapa(3) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao" v-if="nomeEmpresa != 'GENIAL'">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Dados Bancários</span>
                        </div>
                        <span class="desc">Suas contas bancarias</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(4), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(4)}"  @click="abrirEditor(4)">{{verificaSeJaConcluiuEtapa(4) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Endereço</span>
                        </div>
                        <span class="desc">Informações pessoais do seu cadastro.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(5), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(5)}"  @click="abrirEditor(5)">{{verificaSeJaConcluiuEtapa(5) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="agrupamento-quadros">
                    <div class="quadro-configuracao quadro-configuracao-primeiro">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Documentos</span>
                        </div>
                        <span class="desc">Arquivos anexados</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(6), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(6)}"  @click="abrirEditor(6)">{{verificaSeJaConcluiuEtapa(6) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Declarações</span>
                        </div>
                        <span class="desc">Termos aceitos</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(7), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(7)}"  @click="abrirEditor(7)">{{verificaSeJaConcluiuEtapa(7) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Produtos</span>
                        </div>
                        <span class="desc">Produtos com base no seu perfil investidor.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(8), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(8)}"  @click="abrirEditor(8)">{{verificaSeJaConcluiuEtapa(8) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="editar && numEtapa != 9">
                <CadastroPJ v-model:Edicao="editar" :BloquearSalvarIsolado="habilitaRenovacao" />
            </div>
        </div>
        <div class="quadros-configuracoes" v-if="user?.TipoCliente == 'Fundos'">
            <div style="width: 100%; display: inline-flex;">
                <div class="voltar-dash"  style="width: 80px;" v-if="editar && numEtapa != 9">
                    <button type="button" class="submit-button white-button" style="cursor: pointer; margin-top: 10px;"
                        @click="sairEdicao()">Voltar</button>
                </div>
                <div class="desc-dash" style="width: 30%; display: grid;">
                    <span class="title">Cadastro</span>
                    <span class="subtitle" style="color: #475467">Se necessário, revise seus dados cadastrados
                        abaixo</span>
                </div>
            </div>
            <div v-if="!editar || numEtapa == 9">
                <div class="agrupamento-quadros">
                    <div class="quadro-configuracao quadro-configuracao-primeiro">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Dados Cadastrais</span>
                        </div>
                        <span class="desc">Informações seu cadastro.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(0), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(0)}"  @click="abrirEditor(0)">{{verificaSeJaConcluiuEtapa(0) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Procuradores</span>
                        </div>
                        <span class="desc">Informações dos procuradores da empresa.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(1), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(1)}"  @click="abrirEditor(1)">{{verificaSeJaConcluiuEtapa(1) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Participantes</span>
                        </div>
                        <span class="desc">Informações dos participantes da empresa.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(2), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(2)}"  @click="abrirEditor(2)">{{verificaSeJaConcluiuEtapa(2) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="agrupamento-quadros">
                    <div class="quadro-configuracao  quadro-configuracao-primeiro">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Dados Financeiros</span>
                        </div>
                        <span class="desc">Situação financeira e patrimonial</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(3), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(3)}"  @click="abrirEditor(3)">{{verificaSeJaConcluiuEtapa(3) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao" v-if="nomeEmpresa != 'GENIAL'">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Dados Bancários</span>
                        </div>
                        <span class="desc">Suas contas bancarias</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(4), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(4)}"  @click="abrirEditor(4)">{{verificaSeJaConcluiuEtapa(0) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Documentos</span>
                        </div>
                        <span class="desc">Arquivos anexados</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(5), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(5)}"  @click="abrirEditor(5)">{{verificaSeJaConcluiuEtapa(0) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="agrupamento-quadros">
                    <div class="quadro-configuracao quadro-configuracao-primeiro">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Declarações</span>
                        </div>
                        <span class="desc">Informações diversas</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(6), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(6)}"  @click="abrirEditor(6)">{{verificaSeJaConcluiuEtapa(0) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">FATCA</span>
                        </div>
                        <span class="desc">Foreign Account Tax Compliance Act.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(7), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(7)}"  @click="abrirEditor(7)">{{verificaSeJaConcluiuEtapa(0) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="quadro-configuracao">
                        <div class="configuracao-header">
                            <img src="@/assets/user.png" alt="Dados Cadastrais" />
                            <span class="title">Produtos</span>
                        </div>
                        <span class="desc">Produtos com base no seu perfil investidor.</span>
                        <div class="footer">
                            <div class="buttonsAcoes">
                                <button class="btnDefault" :class="{btnLaranja: habilitaRenovacao && !verificaSeJaConcluiuEtapa(8), btnVerde: habilitaRenovacao && verificaSeJaConcluiuEtapa(8)}"  @click="abrirEditor(8)">{{verificaSeJaConcluiuEtapa(0) && habilitaRenovacao ? 'Dados Atualizados' : labelAbrirForm}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="editar && numEtapa != 9">
                <CadastroFI v-model:Edicao="editar" :BloquearSalvarIsolado="habilitaRenovacao"/>
            </div>
        </div>
        <ModalQuestionario />
        <ModalInformativoSaibaMais />
        <ModalAlterarSenha />
        <ModalCadastroVencido :isFundos="user?.TipoCliente == 'Fundos'" />

        <ModalAviso 
        :id="'ModalRenovacao'"
        :titulo="'Atenção: Seu cadastro está próximo do vencimento!'" 
        :labelOpcoes="'Deseja realizar a atualização agora?'"
        :botoes="[
            { texto: 'Sim, atualizar agora', acao: renovarCadastro },
            { texto: 'Lembrar depois', emit: 'fechar' }
        ]"
        />

         <ModalVisualizarPosicao />

        <ModalAviso 
        :id="'ModalConfirmar'"
        :titulo="'Atenção: Confirme o envio das alterações!'" 
        :labelOpcoes="'Ao clicar em Enviar cadastro atualizado, todas as informações salvas serão enviadas para análise e registro. '"
        :botoes="[
            { texto: 'Enviar cadastro atualizado', acao: enviarCadastro },
            { texto: 'Ainda não terminei de atualizar', acao: abrirDivCadastroAlterado }
        ]"
        />

    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import api from '@/api/axios';
import CadastroPF from './Cadastro/PF/CadastroPF_Passo_1.vue';
import CadastroPJ from './Cadastro/PJ/CadastroPJ_Passo_1.vue';
import CadastroFI from './Cadastro/FI/CadastroFI_Passo_1.vue';
import ModalCadastroVencido from '@/views/Login/ModalCadastroVencido.vue'
import ModalQuestionario from '@/views/Cadastro/Questionario/ModalQuestionario.vue'
import ModalInformativoSaibaMais from '@/views/Cadastro/SaibaMais/ModalInformativoSaibaMais.vue'
import ModalAlterarSenha from './Cadastro/AlterarSenha/ModalAlterarSenha.vue'
import ModalAviso from './Cadastro/Utilitarios/ModalAviso.vue'
import ModalVisualizarPosicao from './Dashboard/ModalVisualizarPosicao.vue'

export default {
    name: 'DashboardInicio',
    components: {
        CadastroPF, ModalQuestionario, CadastroPJ, 
        CadastroFI, ModalInformativoSaibaMais, 
        ModalAlterarSenha, ModalCadastroVencido,
        ModalAviso, ModalVisualizarPosicao
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            perfilCliente: 'GET_PERFIL_CLIENTE',
            getConfiguracoes: 'GET_CONFIGURACOES',
            etapasConcluidas: 'GET_ETAPA_CONCLUIDA',
            getConcluir: 'GET_FICHA_CONCLUIR',
            perfilSuitabilityPreview: 'GET_SUITABILITY_PREVIEW',
            getModalQuestionario: 'GET_MODAL_QUESTIONARIO',
        }),
        labelAbrirForm(){
            return this.habilitaRenovacao ? 'Atualizar dados' : 'Editar dados'
        },
        labelAbrirQuestionario(){
            return this.habilitaRenovacao ? 'Atualizar questionário' : 'Refazer questionário'
        },
        possuiMockPosicaoPas(){
            return process.env.VUE_APP_POSSUI_MOCK_POSICAO_PAS == 1 ? true : false
        },
        edicaoConcluida(){
            if(this.user == null){
                return false;
            }

            if(this.user.TipoCliente == 'Pessoa Física'){

                    const etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 9];

                    if(this.nomeEmpresa.toUpperCase() != 'GENIAL'){
                        etapasObrigatorias.push(4);
                    }

                    const etapasConcluidas = Array.isArray(this.etapasConcluidas)
                    ? this.etapasConcluidas.filter(e => typeof e === 'number')
                    : [];


                     var concluidoPF = Array.isArray(etapasConcluidas) &&
                    etapasObrigatorias.every(etapa =>
                        etapasConcluidas.includes(etapa)
                    );

                    if(concluidoPF){
                        this.$store.commit('SET_MODAL_AVISO', 'ModalConfirmar');
                    }

                    
                    return concluidoPF;

            } else if(this.user.TipoCliente.toUpperCase() != 'FUNDOS'){
                  const etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 8, 9];

                    if(this.nomeEmpresa.toUpperCase() != 'GENIAL'){
                        etapasObrigatorias.push(4);
                    }

                    const etapasConcluidasPJ = Array.isArray(this.etapasConcluidas)
                    ? this.etapasConcluidas.filter(e => typeof e === 'number')
                    : [];


                    var concluido = Array.isArray(etapasConcluidasPJ) &&
                    etapasObrigatorias.every(etapa =>
                        etapasConcluidasPJ.includes(etapa)
                    );

                    if(concluido){
                        this.$store.commit('SET_MODAL_AVISO', 'ModalConfirmar');
                    }

                    
                    return concluido;

            }
            else
            {

                    const etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 8];

                    if(this.nomeEmpresa.toUpperCase() != 'GENIAL'){
                        etapasObrigatorias.push(4);
                    }

                    const etapasConcluidasFI = Array.isArray(this.etapasConcluidas)
                    ? this.etapasConcluidas.filter(e => typeof e === 'number')
                    : [];


                    concluido = Array.isArray(etapasConcluidasFI) &&
                        etapasObrigatorias.every(etapa =>
                            etapasConcluidasFI.includes(etapa)
                        );

                    if(concluido){
                        this.$store.commit('SET_MODAL_AVISO', 'ModalConfirmar');
                    }
                    return concluido;
            }
        }
    },
    data() {
        return {
            habilitarModalCadastroAlterado: false,
            enviarCadastroIsolado: false,
            inicializado: false,
            verifyStatusCadastro: false,
            nomeEmpresa: '',
            habilitaRenovacao: false,
            dadosUsuario: {
                PerfilRisco: '',
            },
            loginSession: {
                Usuario: null,
                Senha: null,
            },
            enviarCadastroRenovacao: false,
            editar: false,
            numEtapa: 0,
            messageError: null,
            erro: false,
            configuracaoToken: 'n',
        };
    },
    abrirDadosCadastraisPF() {
        this.$router.push({ name: 'CadastroPF_Passo_1' });
    },
    beforeUnmount() {
        window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    },
    async mounted() {

        
        this.$store.commit('SET_ETAPA_CONCLUIDA', [])
        this.$store.commit('SET_ENVIAR_CADASTRO', false)
        this.$store.commit('SET_MODAL_AVISO', false);
        this.$store.commit("SET_MODAL_CADASTRO_VENCIDO", false);

        this.dadosUsuario.nome = localStorage.getItem('nomeRazaoSocial');
        this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;

        await this.fetchConfiguracao(['Modo de autenticação']);
        this.configuracaoToken = this.getConfiguracoes('Modo de autenticação')?.Valor != '2' ? 'N' : 'S';

        if (this.user.TipoCliente == 'Pessoa Física' && this.user.StatusCadastro == 0) {
            this.$router.push({ name: 'CadastroPF_Passo_1' });
        } else if (this.user.TipoCliente == 'Pessoa Jurídica' && this.user.StatusCadastro == 0) {
            this.$router.push({ name: 'CadastroPJ_Passo_1' });
        } else if (this.user.TipoCliente == 'Fundos' && this.user.StatusCadastro == 0) {
            this.$router.push({ name: 'CadastroFI_Passo_1' });
        } else if (this.user.StatusCadastro == 1) {
            this.$router.push({ name: 'Dashboard' });
        }

        this.verifyStatusCadastro = true;

        this.$store.commit("SET_MODAL_QUESTIONARIO", false);
        this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", false);

        api.get(`suitability`)
            .then((retorno) => {
                if (retorno.status == 200) {
                    this.dadosUsuario.PerfilRisco = retorno?.data?.data[0]?.PerfilRisco;
                    if(retorno?.data?.data[0]){
                    this.user.StatusCadastro = retorno?.data?.data[0]?.StatusCadastro;
                    this.$store.commit('SET_USER', this.user);
                    }
                    this.processarInicio();
                }
            })
        

        
    },
    watch: {
        getModalQuestionario(){
            if(this.getModalQuestionario){
                this.abrirEditor(9);
            }
        },
        edicaoConcluida(novoValor){
            if(novoValor){
                this.habilitarModalCadastroAlterado = true;
            }
        },
        getConcluir(){
            if(this.getConcluir == false && (this.etapasConcluidas.length > 1 || !this.habilitaRenovacao) && this.inicializado){
                this.$store.commit("SET_ETAPA_CONCLUIDA", null);
                this.habilitaRenovacao = false;
                this.habilitarModalCadastroAlterado = false;
            }
        },
        perfilCliente() {
            if (this.perfilCliente)
                if (this.perfilCliente[0]) 
                {
                    this.dadosUsuario = this.perfilCliente[0];

                    if(this.perfilSuitabilityPreview?.Id > 0){
                        this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_PREVIEW', this.perfilSuitabilityPreview?.Id);
                    }else{
                        this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS');  
                    }

                    this.$store.dispatch('FETCH_CONSULTA_LISTA_PRODUTOS_CLIENTE');
                }
        }
    },
    methods: {
        ...mapActions({
            fetchConfiguracao: 'FETCH_CONFIGURACOES'
        }),
        visualizarPosicao() {
            this.$store.commit("SET_MODAL_VISUALIZAR_POSICAO", true);
        },
        processarInicio(){
            if(this.user?.StatusCadastro == 2)
            {
                window.addEventListener('beforeunload', this.beforeUnloadHandler);

                api.get(`cliente/ConsultaLembreteVencimento`)
                    .then((retorno) => {
                        if (retorno.status == 200) {
                            if(retorno?.data?.data)
                            {
                                this.$store.commit('SET_MODAL_AVISO', 'ModalRenovacao');
                            }else{
                                this.enviarCadastroIsolado = true;
                            }
                        }
                })
            }else if(this.user?.StatusCadastro == 3){
                this.habilitaRenovacao = true;
                window.addEventListener('beforeunload', this.beforeUnloadHandler);
                this.$store.commit("SET_MODAL_CADASTRO_VENCIDO", true);
            }
            this.inicializado = true;
        },
        abrirDivCadastroAlterado(){
          this.habilitarModalCadastroAlterado = true;  
          this.$store.commit('SET_MODAL_AVISO', false);
        },
        beforeUnloadHandler(event) {
            event.preventDefault();
            event.returnValue = '';
        },
        verificaSeJaConcluiuEtapa(etapa) {
              return Array.isArray(this.etapasConcluidas) && this.etapasConcluidas.includes(etapa);
        },
        renovarCadastro(){
            this.habilitaRenovacao = true;
            this.abrirQuestionario();
        },
        enviarCadastro(){
            this.editar = true;
            this.$store.commit('SET_ENVIAR_CADASTRO', true)
        },
        alterarSenha() {
            this.$store.commit('SET_ABRIR_ALTERAR_SENHA', true)
        },
        async downloadFicha() {
            try {
                 
                const response = await api.get('/Cliente/pdf', {
                    responseType: 'arraybuffer'
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'ficha.pdf');
                document.body.appendChild(link);
                link.click();
            } catch (error) {
                this.$swal({
                    icon: 'error',
                    title: 'Oops...',
                    text: `Falha ao gerar ficha de cadastro`,
                });
            }
        },
        sairEdicao() {
            this.editar = false;
        },
        abrirEditor(numEtapa) {
            this.numEtapa = numEtapa;
            this.$store.commit('SET_ETAPA_CADASTRO', numEtapa)
            this.editar = true;
        },
        logoff() {
            this.$store.dispatch('auth/logout');
        },
        abrirQuestionario() {
            this.$store.commit("SET_MODAL_QUESTIONARIO", true);
        },
        abrirSaibaMais() {
            this.$store.commit("SET_MODAL_SAIBA_MAIS_INFORMATIVO", true);
        }
    }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Gabarito:wght@400;500;600&display=swap');

/* Estilos globais */
body,
html {
    height: 100%;
    margin: 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
}

.btnLaranja{
    color: #EC7644 !important;
}

.btnVerde{
    color: #45a94d !important;
}

.btnFundoLaranja{
    background-color: #EC7644 !important;
    border-color: #EC7644 !important;
}

.agrupamento-quadros {
    width: 100%;
    display: inline-flex;
}

.quadros-configuracoes {
    width: 100%;
    margin-top: 20px;
    display: grid;

    .title {
        font-family: 'Inter';
        font-weight: 600;
        font-size: 18px;
        line-height: 28px;
        padding-top: 8px;
    }

    .subtitle {
        font-family: 'Inter';
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #475467;
    }

    .desc {
        font-family: 'Inter';
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #475467;
    }

    .footer {
        height: 30px;
        margin-top: 0px;
        border-top: 1px #D0D5DD solid;

        .buttonsAcoes {
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;

            .btnDefault {
                height: 40px;
                font-family: 'Inter', sans-serif;
                background-color: white;
                color: #344054;
                line-height: 20px;
                font-weight: 600;
                font-size: 14px;
                width: 140px;
                border: 0px solid #D0D5DD;
                cursor: pointer;
                margin-right: 0px;
            }
        }
    }

    .quadro-configuracao-primeiro {
        margin-left: 0px !important;
    }

    .quadro-configuracao {
        border: 1px #D0D5DD solid;
        height: 140px; // Reduced height
        width: 30%;
        border-radius: 8px;
        padding: 20px 16px 10px 16px;
        display: grid;
        margin-left: 15px;
        margin-top: 20px;

        .configuracao-header {
            display: flex;
            align-items: center;
        }

        img {
            height: 50px;
            width: 50px;
        }

        .title {
            font-family: 'Inter';
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
        }

        .subtitle {
            font-family: 'Inter';
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #475467;
        }
    }
}

.quadro-inicial {
    width: 100%;
    display: inline-flex;
    margin-top: 20px;
}

.quadro-perfil {
    border: 1px #D0D5DD solid;
    height: 120px; // Reduced height
    width: 70%;
    border-radius: 8px;
    padding: 20px 16px 20px 16px;
    display: grid;
    margin-left: 20px;

    .status {
        font-family: 'Inter';
        font-weight: 600;
        font-size: 18px;
        line-height: 20px;
    }

    .desc {
        font-family: 'Inter';
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
    }
}

.quadro-perfil-azul{
    border: 1px #00235c(24, 46, 82)id;
    background-color: #00235c;
    color: #FFF;
}

.buttonsAcoes {
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;

    .btnBlue {
        height: 40px;
        font-family: 'Inter', sans-serif;
        background-color: #00235C;
        color: white;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        border: 1px solid #00235C;
        border-radius: 8px;
        widows: 88px;
        cursor: pointer;
        margin-right: 35px;
    }

    .btnAmarelo {
        height: 40px;
        font-family: 'Inter', sans-serif;
        background-color: #eec523;
        color: #00235C;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        border: 1px solid #FFF;
        border-radius: 8px;
        widows: 88px;
        cursor: pointer;
        margin-right: 35px;
    }

    .btnDefault {
        height: 40px;
        font-family: 'Inter', sans-serif;
        background-color: white;
        color: #344054;
        line-height: 20px;
        font-weight: 600;
        font-size: 14px;
        border: 1px solid #D0D5DD;
        border-radius: 8px;
        width: 190px;
        cursor: pointer;
    }
}

.quadro-status-cadastro {
    border: 1px #D0D5DD solid;
    height: 120px; // Reduced height
    width: 25%;
    border-radius: 8px;
    padding: 20px 16px 20px 16px;
    display: grid;

    .status-cadastro-content {
        display: flex;
        align-items: center;
    }

    img {
        height: 50px;
        width: 50px;
        margin-right: 10px; // Add some space between the image and the text
    }

    .status-text {
        display: flex;
        flex-direction: column;
    }

    .status {
        font-family: 'Inter';
        font-weight: 600;
        font-size: 18px;
        line-height: 20px;
    }

    .desc {
        font-family: 'Inter';
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
    }
}

.container {
    align-items: self-start;

    .header {
        width: 100%;
        height: 50px;
        align-items: self-start;

        span {
            font-family: 'Gabarito', sans-serif;
            font-weight: 500;
            font-size: 30px;
            line-height: 38px;
            margin-top: 20px;
            padding-bottom: 20px;
        }
    }
}

.site-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0rem 2rem;
    background-color: #fff;
}

.logo img {
    height: 32px;
    width: 142px;
}

.navigation ul {
    list-style: none;
    display: flex;
    gap: 1rem;
}

.navigation li {
    padding: 0.5rem 1rem;
}

.navigation a {
    text-decoration: none;
    color: #000;
}

.navigation a.router-link-active {
    color: #00235C;
}

.navigation a.router-link-exact-active {
    background-color: #00235C;
    color: #fff;
    border-radius: 5px;
    padding: 0.5rem 1rem;
}

.container {
    display: flex;
    flex-direction: column;
    align-items: self-start;
    justify-content: center;
    padding: 80px;
    padding-top: 0px;
    border-radius: 10px;
    background-color: white;
    border-radius: 8px;
}

.logomark {
    width: 54px;
    height: 43.2px;
}

.header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
}

.header h2 {
    width: 360px;
    height: 38px;
    font-family: 'Gabarito', sans-serif;
    font-weight: 600;
    font-size: 30px;
    line-height: 38px;
    text-align: center;
    margin: 0 auto;
    color: #101828;
    margin-top: 20px;
}

.header p {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #6E6E6E;
}

.footer p {
    font-family: 'Inter', sans-serif;
    color: #667085;
    font-size: 16px;
    line-height: 24px;
}

.footer a {
    font-weight: 600;
    color: #101828;
    text-decoration: none;
}

button {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: 0;
    text-align: left;
}

.entrar-button {
    color: #667085;
    background: white;
}

input {
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    padding: 10px;
    margin-bottom: 16px;
    border: 1px solid #ccc;
    border-radius: 8px;
    box-sizing: border-box;
    width: 100%;
}

.erroBorder {
    border: 1px solid #E73D3D !important;
    margin-bottom: 0px;
}

.erro {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    margin-top: 0px;
    color: #E73D3D;
}

.form .input-field label {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #344054;
}

form {
    display: flex;
    flex-direction: column;
}

input {
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

button {
    padding: 10px;
    background-color: #00235C;
    color: white;
    border: none;
    border-radius: 4px;
    text-align: center;
}

@media (max-width: 600px) {
    .login-container {
        margin: 20px;
        padding: 10px;
    }

    input,
    button {
        margin-bottom: 10px;
    }
}

h2 {
    text-align: center;
    margin-bottom: 20px;
}

.forgot-password {
    font-family: 'Inter', sans-serif;
    display: block;
    text-align: center;
    margin-bottom: 20px;
    font-weight: 600;
    color: #00064F;
    text-decoration: none;
}

.signup {
    text-align: center;
    margin-top: 20px;
}

.signup a {
    color: blue;
    text-decoration: none;
}



</style>